/* ───────────────────── API HELPERS ───────────────────── */
export const API = "/api";

export async function apiGet(path, token) {
  const headers = {};
  if (token) headers["x-auth-token"] = token;
  const res = await fetch(API + path, { headers });
  if (!res.ok) throw new Error((await res.json()).error || res.statusText);
  return res.json();
}

export async function apiPost(path, body, token, adminCode) {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["x-auth-token"] = token;
  if (adminCode) headers["x-admin-code"] = adminCode;
  const res = await fetch(API + path, { method: "POST", headers, body: JSON.stringify(body) });
  if (!res.ok) throw new Error((await res.json()).error || res.statusText);
  return res.json();
}

export async function apiPut(path, body, adminCode) {
  const headers = { "Content-Type": "application/json" };
  if (adminCode) headers["x-admin-code"] = adminCode;
  const res = await fetch(API + path, { method: "PUT", headers, body: JSON.stringify(body) });
  if (!res.ok) throw new Error((await res.json()).error || res.statusText);
  return res.json();
}

export async function apiDelete(path, adminCode) {
  const headers = {};
  if (adminCode) headers["x-admin-code"] = adminCode;
  const res = await fetch(API + path, { method: "DELETE", headers });
  if (!res.ok) throw new Error((await res.json()).error || res.statusText);
  return res.json();
}
